import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../CSS/style.css";
import axios from "axios";
import strings from "../String";

const EndUserLicenseAgreement = () => {
  const navigate = useNavigate();

  useEffect(() => {
    //document.body.style.backgroundColor = "#ffffff";
    let checkTheme = document.getElementById("root");
    if (checkTheme.classList.contains("dark-mode")) {
      checkTheme.classList.remove("dark-mode");
    }
    //document.body.style.backgroundColor = "#ffffff";
  });

  // useEffect(() => {
  //   // Load remembered email from local storage
  //   const themeColor = localStorage.getItem('themeColor');
  //   console.log("Inside Dark Mode")
  //   //const rememberedPassword=localStorage.getItem('rememberedPassword');
  //   if (themeColor==='light_mode') {
  //     console.log("Inside Dark Mode")
  //     document.body.classList.add('dark-mode');
  //   }
  //   else{
  //     document.body.classList.remove('dark-mode');
  //   }
  // }, []);


  return (
    <section class="bg-white">
      <div class="container eulaDocMain">
        <div class="row headerLogo">
          <div class="col">
            <div class="eulaDocCopilotDiv">
              <img
                src="Img/cimatron-logo-720x177.png"
                alt="Cimatron-logo"
                className="img-fluid d-block eulaDocLogo"
              /> <div class="vr"></div> <img
                src="Img/copilot-icon-text-bubble-black-512.png"
                alt="copilot-icon-text-bubble-white"
                className="eulaDocCopilot-icon" id="copilot-icon"
              /> <h3 class="px-2">Cimatron Copilot</h3>
            </div>
          </div>
        </div>
        <div class="row eula-content">
          <div class="col">
            <div class="pb-2">
              <h1>END-USER LICENSE AGREEMENT</h1>
              <hr />
            </div>
            <div class="pb-2">
              <p>
                IMPORTANT - READ CAREFULLY THE FOLLOWING TERMS AND CONDITIONS
                (these "TERMS" or the "AGREEMENT") BEFORE INSTALLING THE
                SOFTWARE. BY SELECTING THE "I ACCEPT" BUTTON BELOW, OR BY
                INSTALLING THE SOFTWARE, YOU AGREE TO BE BOUND BY THESE TERMS.
                IF YOU SELECT "I DO NOT ACCEPT", THE INSTALLATION PROCESS WILL
                NOT PROCEED. DO NOT SELECT "I ACCEPT" OR INSTALL THE SOFTWARE
                UNTIL YOU HAVE CAREFULLY READ, UNDERSTOOD, AND AGREED TO THESE
                TERMS. IF YOU DO NOT WISH TO AGREE TO THESE TERMS DO NOT INSTALL
                THE SOFTWARE.
              </p>
              <p>
                FURTHERMORE, YOU HEREBY WAIVE ANY RIGHTS OR REQUIREMENTS UNDER
                ANY LAWS OR REGULATIONS IN ANY JURISDICTION WHICH REQUIRE AN
                ORIGINAL (NON-ELECTRONIC) SIGNATURE OR DELIVERY OR RETENTION OF
                NON-ELECTRONIC RECORDS, TO THE EXTENT PERMITTED UNDER APPLICABLE
                MANDATORY LAW.
              </p>
              <p>
                THESE TERMS AND THE CONDITIONS AND LIMITATIONS SET FORTH IN THE
                LICENSE FILE YOU RECEIVED FROM CIMATRON OR ANY OF ITS AUTHORIZED
                DISTRIBUTORS TOGETHER WITH THE SOFTWARE ("LICENSE FILE")
                CONSTITUTE THE COMPLETE AND EXCLUSIVE STATEMENT OF THE AGREEMENT
                BETWEEN YOU, OR THE COMPANY ON WHOSE BEHALF YOU ARE INSTALLING
                THE SOFTWARE ("YOU"), AND CIMATRON, WHICH SUPERSEDES ANY
                PROPOSAL OR PRIOR AGREEMENT, ORAL OR WRITTEN, AND ANY OTHER
                COMMUNICATION RELATING TO THE SUBJECT MATTER OF THESE TERMS.
              </p>
              <p>
                These TERMS govern the use of Cimatron , LICENSE FILE, product
                upgrades and related written materials (the "SOFTWARE"){" "}
                <span class="underline-text">
                  and also governs, together with{" "}
                  <Link to="/schedule-a-terms-and-conditions">Schedule A</Link>,
                  the use of CIMATRON AI COPILOT.
                </span>
              </p>
              <p>
                The term "SOFTWARE" also includes any components or portions of
                the SOFTWARE, including components provided by CIMATRONs
                licensors and suppliers, upgrades, modified versions or updates
                of the SOFTWARE or accompanying documentation which may be
                provided to YOU by CIMATRON or any of its authorized
                distributors. A copy of the SOFTWARE will be licensed to YOU as
                the registered end user.
              </p>
            </div>
            <div class="pb-2">
              <p>
                <strong>
                  YOUR use of the SOFTWARE will be subject to the following
                  terms and conditions:
                </strong>
              </p>
              <h4>1. USE OF THE SOFTWARE</h4>
              <hr />
              <p>
                Subject to the terms of these TERMS (including payment of the
                applicable license fee) and the limitations in the LICENSE FILE,
                CIMATRON grants YOU a limited, non-exclusive and
                non-transferable license, solely during the periods set forth in
                the LICENSE FILE, to install and operate the SOFTWARE, in
                machine-executable form only and solely in accordance with the
                associated delivered documentation (the "DOCUMENTATION") for
                YOUR internal business purposes, for the number of concurrent
                seats and/or permitted users set forth in the LICENSE FILE.
              </p>
              <p>
                YOU may install the SOFTWARE in a single location on a hard disk
                or other storage device and YOU may copy the SOFTWARE for backup
                purposes but not for the purpose of using an additional copy. On
                any permitted copies, YOU must reproduce and maintain all
                statements and notices on industrial property rights, copyrights
                and other proprietary notices that appear on or in the SOFTWARE
                and transfer these statements, in an unaltered form to all
                complete and partial copies of machine readable licensed
                material produced by CIMATRON.
              </p>
              <p>
                YOU will not be able to use a prior version of the SOFTWARE to
                open, operate or otherwise make use of any file created with
                this version of the SOFTWARE or with any subsequent version of
                the SOFTWARE.
              </p>
              <h4>
                2. FEEDBACK, USE OF PERSONAL DATA, UPDATING, AND DATA COLLECTION
              </h4>
              <hr />
              <p>
                YOU may contact CIMATRON with input regarding your reactions,
                comments, and suggestions for improvement regarding the
                Software, including but not limited to usability, missing
                features, functional errors, and bug reports. All such reports
                and other feedback provided to CIMATRON may be used by CIMATRON
                for any purpose whatsoever without royalties or other
                compensation of any kind to YOU, and CIMATRON will be the sole
                owner of any and all programs, documentation, inventions, or
                improvements developed by CIMATRON that may relate to such
                reports and feedback. YOU agree that CIMATRON may collect and
                use information gathered as part of support and other services
                provided to YOU. Personal data collected by CIMATRON to enable
                the software license includes the IP Address, User name, PC
                name, and domain name of the computer running the SOFTWARE, as
                well as the email address associated with the license. YOU may
                request CIMATRON permanently delete this personal data at any
                time by contacting technical support. For additional information
                please refer to the{" "}
                <a
                  href="https://www.cimatron.com/en/about-this-site/privacy/privacy-statement"
                  target="_blank"
                >
                  Privacy Notice
                </a>
                . If YOU fail to provide any personal data that is required we
                will not be able to carry out our contractual obligations with
                YOU. YOU acknowledge and agree that the SOFTWARE may cause your
                Device to automatically connect to the Internet to check for
                updates or upgrades that may be available for automatic download
                and to let CIMATRON know that any such update or upgrade has
                installed successfully. CIMATRON may also automatically collect
                and report back to CIMATRON, on an anonymous basis, information
                about online usage of the SOFTWARE and your usage along with
                limited information about the Device, other third-party
                applications, and/or other diagnostic information. CIMATRON will
                act as data processor in providing the CIMATRON AI COPILOT (as
                referred to in section 9 below) and by entering into this
                agreement and Schedule A, You agree to the DPA in Schedule A.1
                (“DPA”). CIMATRON reserves the right to update the DPA and the
                Privacy Notice and YOU are obligated to make sure that your
                users are informed about the content of this section 2 as well
                as the Privacy Notice and the DPA, as updated by CIMATRON from
                time to time.
              </p>
              <h4>3. OWNERSHIP</h4>
              <hr />
              <p>
                YOU acknowledge that CIMATRON and its licensors and suppliers
                retain all title, right, copyright (and any other applicable
                intellectual property right), and interest in and to the
                SOFTWARE, including all DOCUMENTATION, translations,
                enhancements, improvements or other modifications made to or
                derived from the SOFTWARE. These TERMS and the LICENSE FILE do
                not provide YOU with any ownership interest in the SOFTWARE or
                with any other right other than as expressly set forth in these
                TERMS. The SOFTWARE is protected by international copyright law
                and international treaty provisions.
              </p>
              <h4>4. LICENSE RESTRICTIONS</h4>
              <hr />
              <p>
                YOU shall not, nor shall YOU allow third parties, to: (i)
                reverse engineer, decompile, or disassemble all or any portion
                of the SOFTWARE; (ii) distribute, expose, disclose, market,
                rent, lease, loan, sublicense, make available or transfer to any
                third party the SOFTWARE, or use the SOFTWARE in any service
                bureau arrangement; (iii) modify, adapt, alter, or create
                derivative works of the SOFTWARE or merge the SOFTWARE with
                other software; and/or (iv) export the SOFTWARE in violation of
                any applicable regulations. The server and each computer
                permitted to access the SOFTWARE must be in YOUR possession and
                under YOUR control and used only by persons who have a specific
                need to use. We may insert in each copy of the SOFTWARE a
                mechanism to make the SOFTWARE inoperable after a specified
                period of time to ensure full payment thereof. YOU shall take no
                action designed to defeat the operation of any security measure
                incorporated in the SOFTWARE.
              </p>
              <h4>5. RECORDS, AUDIT RIGHTS</h4>
              <hr />
              <p>
                YOU must retain records of copies or partial copies of the
                SOFTWARE, store them in a secure place, and issue information
                about them on CIMATRON s request.
              </p>
              <p>
                CIMATRON shall have the right to audit YOUR compliance with
                these Terms. Upon CIMATRON s request, YOU shall grant CIMATRON
                access to YOUR facilities, equipment, books, records and
                documents and otherwise reasonably cooperate with CIMATRON to
                facilitate any such audit.
              </p>
              <h4>6. NON DISCLOSURE</h4>
              <hr />
              <p>
                YOU acknowledge that the SOFTWARE and all associated
                documentation together with all other proprietary information
                and trade secrets (including the SOFTWARE's structure,
                organization, interfaces, object code and source code) of
                CIMATRON, its licensors, suppliers and distributors (together,
                the "Confidential Information") which comes to YOUR knowledge as
                a result of YOUR relationship with CIMATRON, or its licensors,
                suppliers or distributors, shall be maintained by YOU at all
                times in the strictest of confidence and kept under access and
                use restrictions sufficient to protect unauthorized copying, use
                of disclosure thereof. YOU agree to safeguard the Confidential
                Information with at least the same degree of care that YOU take
                to protect YOUR most valuable confidential and proprietary
                information, which in no event shall be less than a reasonable
                standard of care. YOU acknowledge that the Confidential
                Information is a valuable asset of CIMATRON, and/or its
                licensors, suppliers or distributors and that YOU shall,
                therefore, not disclose the Confidential Information to any
                party whatsoever. If YOU are required by judicial or
                administrative process to disclose any Confidential Information,
                YOU will promptly notify CIMATRON, its licensors, suppliers and
                distributors, as applicable, so as to allow CIMATRON reasonable
                time to oppose such process and cooperate in attempts to
                restrain such disclosure. YOU acknowledge that, in the event of
                a breach of this provision by YOU, legal remedies would be
                inadequate compensation. YOU agree that prior to and in addition
                to any legal remedies obtained for a breach of this provision by
                YOU, CIMATRON, its licensors, suppliers and distributors shall
                be entitled to seek immediate equitable relief against YOU.
              </p>
              <h4>7. LIMITATION OF LIABILITY AND WARRANTY</h4>
              <hr />
              <p>
                ALL SOFTWARE AND SERVICES ARE PROVIDED "AS IS," WITHOUT WARRANTY
                FROM CIMATRON AND ITS LICENSORS AND SUPPLIERS OF ANY KIND,
                EXPRESSED OR IMPLIED, EITHER IN FACT OR BY OPERATION OF LAW,
                STATUTORY OR OTHERWISE (INCLUDING BUT NOT LIMITED TO ANY
                WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
                USE AND NON-INFRINGEMENT). CIMATRON, ITS LICENSORS AND SUPPLIERS
                HAVE NOT, DO NOT AND CANNOT WARRANT THAT THE SOFTWARE WILL BE
                DELIVERED OR PERFORM ERROR-FREE OR WITHOUT INTERRUPTION, OR
                PROVIDE ANY WARRANTY REGARDING THE PERFORMANCE OR RESULTS YOU
                MAY OBTAIN USING THE SOFTWARE OR DOCUMENTATION.
              </p>
              <p>
                TO THE MAXIMUM EXTENT PERMISSIBLE BY LAW, CIMATRON AND ITS
                LICENSORS, SUPPLIERS AND DISTRIBUTORS SHALL HAVE NO LIABILITY
                WITH RESPECT TO THEIR OBLIGATIONS UNDER THESE TERMS OR OTHERWISE
                FOR ANY DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION,
                DIRECT, SPECIAL, INCIDENTAL, INDIRECT, CONSEQUENTIAL, PUNITIVE
                OR EXEMPLARY DAMAGES, DAMAGES FOR LOSS OF BUSINESS, LOSS OF
                PROFITS, BUSINESS INTERRUPTION, LOSS OF INFORMATION, OR
                PECUNIARY LOSS) ARISING OUT OF OR IN CONNECTION WITH THESE TERMS
                AND THE LICENSE FILE, OR THE USE OF OR INABILITY TO USE THE
                SOFTWARE, EVEN IF CIMATRON OR ITS LICENSORS, SUPPLIERS AND
                DISTRIBUTORS OR ONE OF THEIR REPRESENTATIVES HAVE BEEN ADVISED
                OF THE POSSIBILITY OF SUCH DAMAGES, OR ANY CLAIM WHICH HAS BEEN
                OR MAY BE BROUGHT BY ANY THIRD PARTY. IN NO EVENT SHALL CIMATRON
                OR ITS SUPPLIERS AND DISTRIBUTORS BE LIABLE FOR ANY REASON AND
                UPON ANY CAUSE OF ACTION WHATSOEVER RELATING TO ANY THIRD PARTY
                SOFTWARE OR HARDWARE. THE PARTIES ACKNOWLEDGE AND AGREE THAT THE
                LICENSE FEES PAYABLE HEREUNDER, IF ANY, ARE BASED IN PART UPON
                THESE LIMITATIONS, AND THAT THESE LIMITATIONS SHALL APPLY
                NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED
                REMEDY.
              </p>
              <h4>8. BETA PROGRAMS</h4>
              <hr />
              <p>
                CIMATRON may invite You, or You may elect to participate in,
                CIMATRON’s beta or early release program (“Beta Program”). Any
                such license is provided for testing and evaluation purposes and
                not for any commercial or production purposes. CIMATRON does not
                guarantee that a generally available version will be released or
                that all features will become generally available.
              </p>
              <p>
                Beta Programs may require you to provide feedback, either
                voluntarily or in response to survey or information requests
                from CIMATRON, including suggestions, enhancement requests,
                recommendations, or other input (“Feedback”). You agree that any
                Feedback will be the exclusive property of CIMATRON. To the
                extent you own any rights to any Feedback, You hereby grant to
                CIMATRON a fully-paid up, royalty-free, worldwide, transferable,
                sublicensable, and irrevocable license (a) to adapt, modify, and
                create derivative works of the Feedback; and (b) to make, have
                made, use, copy, offer to sell, sell, perform, display,
                distribute, import, and otherwise dispose of the Feedback (and
                adaptations, modifications, and derivative works of the
                Feedback) and any product, technology, or service that
                incorporates, is combined or used with, or marketed for use or
                combination with, any Feedback. Additional terms and
                requirements for Beta Programs may be communicated to you in
                writing, including by electronic mail. In connection with Your
                participation in the Beta Programs, You agree to make use of
                then current version of the Beta Materials made available by
                CIMATRON to You. Upon CIMATRON’s request, You agree to return or
                destroy, or cease use of, all Beta Material. Beta and early
                release licenses are limited term licenses and will permanently
                expire based on the determination of CIMATRON.
              </p>
              <p>
                BETA MATERIALS MAY NOT HAVE BEEN TESTED, MAY NOT BE FREE FROM
                ERRORS, AND ANY DOCUMENTATION PROVIDED IN THE BETA MATERIALS MAY
                BE IN DRAFT FORM. NOTWITHSTANDING ANYTHING TO THE CONTRARY IN
                THIS AGREEMENT, ALL BETA MATERIALS ARE PROVIDED ON AN “AS IS”
                AND “AS AVAILABLE” BASIS, AND WITHOUT WARRANTIES OR INDEMNITIES
                OF ANY KIND. COMPANY DISCLAIMS ALL LIABILITY FOR YOUR USE OF ANY
                BETA MATERIALS.
              </p>
              <h4>9. CIMATRON AI COPILOT </h4>
              <hr />
              <p>
                If You, in connection with your use of the SOFTWARE, have
                received access to use CIMATRON AI COPILOT, the AI chatbot
                feature made available by CIMATRON based on the third party
                cloud solution, you accept and will accept the{" "}
                <a href="/schedule-a-terms-and-conditions">
                  additional terms of use regarding CIMATRON AI COPILOT, in
                  Schedule A{" "}
                </a>{" "}
                as updated from time to time, and SPECIFIALLY THAT CIMATRON AI
                COPILOT IS (i) PROVIDED “AS IS” (ii) SUBJECT TO TESTING AND
                DEVELOPEMENT AND (iii) MAY CONTAIN ERRORS AND GIVE INCOMPLETE OR
                INACCURATE ANSWERS and (iv) A CLOUD BASED SOLUTION THAT COLLECTS
                CERTAIN DATA FROM ITS USERS WHEN USED. CIMATRON WILL NOT BE
                LIABLE FOR OR GIVE ANY WARRANITES OF ANY KIND (INCLUDING
                REGARDING PERFORMANCE, AVAILABILITY, SECURITY, FURTHER UPDATES
                AND QUALITY IMPROVEMENTS) RELATING TO CIMATRON AI COPILOT AND
                MAY AT ANY TIME CANCEL THE ACCESS TO CIMATRON AI COPILOT WITHOUT
                PRIOR NOTICE.
              </p>
              <p>
                To the extent that there is any contradiction between the
                provisions of Schedule A and the provisions of this Agreement,
                the provisions of Schedule A shall prevail, control and govern.
              </p>
              <h4>10. EXPORT RESTRICTIONS </h4>
              <hr />
              <p>
                YOU acknowledge that the SOFTWARE may be subject to
                international rules, regulations, and laws, including U.S. trade
                laws, executive orders, and restrictions that govern the export
                of SOFTWARE. YOU agree to comply with all applicable
                international and national laws that apply to the SOFTWARE as
                well as end-user, end-use and destination restrictions issued by
                national governments, including but not limited to the U.S.
                Export Administration Regulations and U.S. Sanctions Laws.
              </p>
              <p>
                Without derogating from the foregoing, this Agreement is subject
                to European Union, United Nations, United States, and United
                Kingdom regulations, orders or other restrictions regarding the
                sale, import, export, reexport, and transfer from the EU, UN,
                U.S. and U.K. of software, technical data or derivatives thereof
                (“Global Trade Laws and Regulations”). YOU represent and warrant
                that YOU are not a citizen of or located within an embargoed or
                otherwise restricted nation and that YOU are not otherwise
                prohibited under the export control laws from receiving the
                Software. Notwithstanding anything else in this Agreement to the
                contrary, YOU shall not directly or indirectly export (or
                re-export) the SOFTWARE or any derivatives thereof or permit
                transshipment of the same, (i) into (or to a national or
                resident of) Afghanistan, Belarus, Cuba, Iran, Russia, Crimea
                and non-government-controlled areas of the Donetsk, Kherson,
                Luhansk and Zaporizhzhia oblasts of Ukraine, North Korea, Syria
                or any other country subject to Global Trade Laws and
                Regulations and other local economic sanctions or other trade
                controls, (ii) to any country prohibited by applicable laws,
                regulations or orders, including without limitation, those
                regarding the sale, import and export of computer software,
                technical data or derivative of such software or technical data,
                (iii) any country, the laws of which CIMATRON, its licensors and
                suppliers may reasonably determine to be unable to protect
                CIMATRON, its licensor or suppliers intellectual property rights
                in the SOFTWARE or which may cause uncertainty in regards to the
                ability to license and product such rights, (iv) to anyone on
                the U.S. Treasury Department s list of Specially Designated
                Nationals (“SDN”) and Blocked Persons or any entity that is 50
                percent or more owned by an SDN, whether owned directly or
                indirectly, individually or in the aggregate, List of Specially
                Designated Terrorists or List of Specially Designated Narcotics
                Traffickers or the U.S. Commerce Department’s Table of Deny
                Orders, Denied Persons List, Unverified Parties List, Entity
                List, the U.S. State Department’s list of Debarred Parties, or
                any other U.S. laws restricting or prohibiting international
                commercial or financial transactions, or (v) to any country or
                destination for which the U.S. government or U.S. governmental
                agency requires an export license or other approval for export
                without first having obtained such license or other approval.
                YOU recognize and agree that items (i)-(v) may change from time
                to time, CIMATRON in its discretion may choose not to make
                available any product and/or service which, in CIMATRON’s
                determination, fails to comply with legal and/or regulatory
                and/or contractual requirements or restrictions, and/or which
                CIMATRON is otherwise prohibited from exporting or otherwise
                making available (either temporarily or permanently), and YOU
                shall fully cooperate with CIMATRON, its licensors and
                suppliers, to effect compliance with any changes. YOU
                acknowledge and agree that failure or refusal to furnish within
                30 days (or within such shorter time as permitted by applicable
                law) any certificate or disclosure required under applicable
                law, by any governmental authority, or to ensure trade
                compliance upon request from CIMATRON will be the basis for
                immediate termination of this Agreement. YOU represent and
                warrant that YOU shall not, directly or indirectly, sell,
                export, re-export, transfer, retransfer or otherwise release or
                dispose SOFTWARE for any purpose connected with chemical,
                biological or nuclear weapons, or missiles capable of delivering
                such weapons, or for any nuclear explosive or unsafeguarded
                nuclear fuel cycle activity; or for military end-use or to a
                military end-user, including military intelligence end-uses and
                end-users, without obtaining prior approval from CIMATRON and
                all necessary government agencies. YOU further agree that YOU
                are solely responsible for compliance with any import,
                sanctions, and export laws and regulations of the country of
                destination of a permitted export or re-export, and any other
                trade requirement related to a permitted export or re-export.
                YOU represent that YOU maintain an effective export and
                sanctions compliance program in accordance Global Trade Laws and
                Regulations, including the EAR and ITAR, if registered with the
                United States Office of Defense Trade Controls (unless covered
                by one of the exemptions set forth in 22. C.F.R. Part 122) as
                required by the ITAR. During the term of this Agreement, and
                five (5) years thereafter, YOU shall maintain clear and accurate
                books and records related to its activities under this Agreement
                and to the distribution of licenses to CIMATRON Software. During
                normal business hours and subject to reasonable prior notice,
                CIMATRON shall have the right to review and audit, or appoint a
                suitable professional adviser to review and audit, books and
                records to ensure compliance with this Agreement. YOU agree to
                give prompt written notice within five (5) business days in the
                event that, at any time during the term of this Agreement, You
                fail to comply with or have breached any of your warranties
                hereunder. In the event You have not complied, or have breached,
                any of your warranties hereunder, this Agreement shall be null
                and void from the time of such non-compliance or breach. The
                foregoing Export Restrictions in this Section shall survive the
                termination of this Agreement and shall continue in effect with
                respect to all business activities of You and CIMATRON in the
                applicable countries until all such activities have ceased.
              </p>
              <h4>11. U.S. GOVERNMENT USERS </h4>
              <hr />
              <p>
                All SOFTWARE that may be provided to the U.S. Government is
                provided with the commercial license rights and restrictions
                described in this Agreement. By installing, copying or using the
                SOFTWARE, the U.S. Government agrees that the SOFTWARE is
                "commercial computer software" or "commercial computer software
                documentation" within the meaning of FAR Part 12.
              </p>
              <h4>12. TERMINATION </h4>
              <hr />
              <p>
                These TERMS and the license hereunder shall automatically
                terminate upon failure by YOU to comply with its terms and the
                applicable LICENSE FILE. Upon termination of these TERMS, YOU
                shall promptly cease all use and access of the SOFTWARE and (i)
                return to CIMATRON any copies of the SOFTWARE (including the
                LICENSE FILE) in YOUR possession or control, and (ii) certify in
                writing to CIMATRON that all copies of the SOFTWARE in YOUR
                possession have been destroyed.
              </p>
              <h4>13. ASSIGNMENT </h4>
              <hr />
              <p>
                YOU may not transfer or assign YOUR rights under this agreement,
                including, but not limited to the right to use the SOFTWARE,
                except with prior written approval of CIMATRON and as relevant,
                its licensors and suppliers. CIMATRON may transfer or assign its
                rights at its sole discretion and without notice to YOU.
              </p>
              <h4>14. USE OUTSIDE OF COUNTRY</h4>
              <hr />
              <p>
                YOU may not transfer the License outside of the Country in which
                YOU acquired the right to use the SOFTWARE.
              </p>
              <p>
                When a network license is purchased and is installed locally,
                YOU may also enable remote offices to use a license.
              </p>
              <h4>15. GOVERNING LAW AND GENERAL PROVISIONS</h4>
              <hr />
              <p>
                These TERMS will be governed by the laws of the State of New
                York, excluding the application of its conflicts of law rules.
                If any part of these TERMS is found void and unenforceable, the
                balance of these TERMS shall remain valid and enforceable
                according to its terms. YOU agree that the SOFTWARE will not be
                shipped, transferred or exported into any country or used in any
                manner prohibited by the United States Export Administration
                Act, or any other export laws, restrictions or regulations.
              </p>
              <p>
                CIMATRON LTD. - YOU acknowledge that CIMATRON LTD. (and its
                licensors) retain intellectual property rights in portions of
                the SOFTWARE and must use reasonable care in maintaining the
                confidentiality of such portions of the SOFTWARE.
              </p>
              {/* <p>
              Spatial - Portions of this SOFTWARE are owned by Spatial Corp.
              1986 - 2020. All Rights Reserved.
            </p> */}
              <p>
                These TERMS may only be modified in writing, signed by an
                authorized officer of CIMATRON.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EndUserLicenseAgreement;
